module.exports = __webpack_public_path__ + "img/6a_User-Actions.5da7d7cf.png";